import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics, isSupported as analyticsIsSupported } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaEnterpriseProvider, getToken as getAppCheckToken } from 'firebase/app-check';

// App Check (bot/script protection). Paste the reCAPTCHA Enterprise site key
// from Firebase Console -> App Check after registering the web app; leave
// empty to run without App Check (backend enforces only when
// APP_CHECK_ENFORCE=true is set on functions).
const APP_CHECK_SITE_KEY = '';

// Which web-app registration this bundle is (set by webpack DefinePlugin):
// the public chat app or the admin portal. Both live in the church-owned
// project askpastorrob-b6812; separate registrations keep Analytics streams
// and App Check attestations apart.
const APP_TARGET = typeof __APR_APP__ !== 'undefined' ? __APR_APP__ : 'main';

const WEB_APPS = {
  main: { appId: '1:817770410797:web:77d0e28d5979ee506519a4', measurementId: 'G-JJ2KZ1QWW0' },
  admin: { appId: '1:817770410797:web:4d2258a69c078c9c6519a4', measurementId: 'G-552H121KM9' },
};

const firebaseConfig = {
  apiKey: 'AIzaSyCis2C19spo_NRbaLWXVBm9p51hUJ6w8fk',
  authDomain: 'askpastorrob-b6812.firebaseapp.com',
  projectId: 'askpastorrob-b6812',
  storageBucket: 'askpastorrob-b6812.firebasestorage.app',
  messagingSenderId: '817770410797',
  ...(WEB_APPS[APP_TARGET] || WEB_APPS.main),
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const appTarget = APP_TARGET;

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

// Analytics: the public app on real hosts only (never the emulator/dev server)
export let analytics = null;
if (!isLocalhost && APP_TARGET === 'main') {
  analyticsIsSupported()
    .then((supported) => {
      if (supported) analytics = getAnalytics(app);
    })
    .catch(() => { /* analytics unavailable (e.g. blocked) — fine */ });
}

let appCheck = null;
if (APP_CHECK_SITE_KEY && !isLocalhost) {
  try {
    appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(APP_CHECK_SITE_KEY),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (err) {
    console.error('App Check initialization failed:', err);
  }
}

/** Returns an App Check token, or null when App Check isn't configured. */
export async function getAppCheckTokenSafe() {
  if (!appCheck) return null;
  try {
    const result = await getAppCheckToken(appCheck);
    return result.token;
  } catch (err) {
    console.warn('App Check token fetch failed:', err);
    return null;
  }
}

// Connect to emulators if in development
if (window.location.hostname === 'localhost') {
  // Use localhost instead of 127.0.0.1 so that auth tokens generated by the
  // Auth emulator are considered same-origin and are automatically attached
  // to callable Function requests.
  connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, 'localhost', 8080);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export default app;
